import { render, staticRenderFns } from "./PlanetNotes.vue?vue&type=template&id=66924e7e&"
import script from "./PlanetNotes.vue?vue&type=script&lang=js&"
export * from "./PlanetNotes.vue?vue&type=script&lang=js&"
import style0 from "./PlanetNotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports